const LvOnlyMode : boolean = true; //If enabled, will redirect any language to lv and hide the language switcher

export default class LangService {
  public isLvOnly() : boolean {
    return LvOnlyMode;
  }
}

export const langService = new LangService();
